import { PAYMENTS_SECTIONS_ROUTES } from '@/models/app-internal/permissions.model';
import { RouteComponent, RouteRecordRaw } from 'vue-router';

export const currencyRoutes: RouteRecordRaw[] = [
  {
    name: PAYMENTS_SECTIONS_ROUTES.CURRENCY,
    path: `/${PAYMENTS_SECTIONS_ROUTES.CURRENCY}`,
    component: async(): Promise<RouteComponent> =>
      await import('@/layouts/currency-page/currency-page.vue'),
  },
];
